import Twig from 'twig'
import { setEvent } from '../functions'

/**
 * ViewModel //ViewModel
 *
 * @returns {undefined}
 */
export class ViewModel {
  constructor(objectName, $element, controller) {
    this.name = objectName
    this.$element = $element

    this.controller = controller
    if (this.$element.hasClass(`${this.name}-apply`)) return

    // 再度適応を防ぐ
    this.$element.addClass(`${this.name}-apply`)
  }

  /**
   * store // コントローラーのstoreを返す
   *
   * @return {object} store
   */
  store() {
    return this.controller.store()
  }

  /**
   * hook. // コントローラーのhookCallを実行
   *
   * @param {string} target // js class name
   * @param {string} objectName // 適応するobjectName
   */
  hook(objectName, fragment = null) {
    this.controller.hookCall(objectName, fragment)
  }

  /**
   * on // コントローラートリガーの設定
   *
   * @param {string} eventName
   * @param {function} callback
   */
  on(eventName, callback) {
    this.controller.on(this.name, eventName, callback)
  }

  /**
   * trigger // コントローラートリガーの設定
   *
   * @param {string} eventName
   * @param {any} data
   */
  trigger(eventName, data = null) {
    this.controller.trigger(eventName, data)
  }

  /**
   * template. // オーバーライド対象
   */
  template() {
    return ''
  }

  /**
   * view.
   *
   * @param {object} obj
   */
  view(obj = {}) {
    const t = this.template()
    const template = Twig.twig({
      data: t,
    })
    return setEvent(template.render(obj), this)
  }

  /**
   * attr // this.$elementの属性を取得する
   *
   * @param {string} attrName // 属性名
   * @param {any} myDefault // 値がない場合のデフォルト値
   */
  attr(attrName, myDefault = null) {
    const attr = this.$element.attr(attrName)
    if (attr) return attr
    if (attr === '0') return attr
    if (attr === 0) return attr
    return myDefault
  }
}
